export var NmibleService;
(function (NmibleService) {
    let PaymentDetailsType;
    (function (PaymentDetailsType) {
        PaymentDetailsType["VIRTUAL_CARD"] = "VIRTUAL_CARD";
        PaymentDetailsType["BANK_ACCOUNT"] = "BANK_ACCOUNT";
        PaymentDetailsType["DEBIT_CARD"] = "DEBIT_CARD";
        PaymentDetailsType["CHEQUE"] = "CHEQUE";
        PaymentDetailsType["PHYSICAL_CARD"] = "PHYSICAL_CARD";
        PaymentDetailsType["EXPENSE_CARD"] = "EXPENSE_CARD";
        PaymentDetailsType["PHYSICAL_EXPENSE_CARD"] = "PHYSICAL_EXPENSE_CARD";
    })(PaymentDetailsType = NmibleService.PaymentDetailsType || (NmibleService.PaymentDetailsType = {}));
})(NmibleService || (NmibleService = {}));
